import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints } from "plos/src/styles/breakpoints";
import { vars } from "plos/src/styles/theme.css";

export const pointsScoreboard = style({
  display: "flex",
  alignItems: "stretch",
  justifyContent: "space-around",
  textAlign: "center",
});

export const scoreboardPrimary = style({
  borderRadius: vars.radii.m,
  width: 110,
  height: 110,
  "@media": {
    [`screen and (min-width: ${breakpoints[5]})`]: {
      width: 130,
      height: 130,
    },
  },
});

export const scoreboardSecondary = style({
  flex: "0 0 31%",
  alignItems: "center",
  "@media": {
    [`screen and (min-width: ${breakpoints[5]})`]: {
      display: "flex",
      flexBasis: "40%",
      justifyContent: "center",
    },
  },
});

export const secondaryPanel = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  "@media": {
    [`(min-width: ${breakpoints[5]})`]: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      gap: vars.space["4xl"],
    },
  },
});

export const secondaryHeading = style({
  margin: `${vars.space["2xs"]} 0`,
  color: vars.colors.onSurface,
  fontFamily: vars.fonts.regular,
  fontSize: vars.fontSizes.body.s,
});

export const secondaryValue = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: vars.space.xs,
  color: vars.colors.onSurface,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.heading.l,
  "@media": {
    [`(min-width: ${breakpoints[5]})`]: {
      fontSize: vars.fontSizes.heading["2xl"],
    },
  },
});

export const transfersValue = style({
  borderRadius: vars.radii.s,
  backgroundColor: vars.colors.error,
  padding: vars.space["2xs"],
  color: vars.colors.white,
  fontSize: vars.fontSizes.heading.s,
  "@media": {
    [`(min-width: ${breakpoints[5]})`]: {
      fontSize: vars.fontSizes.heading.l,
    },
  },
});

export const secondaryItem = style({
  selectors: {
    "&:last-child": {
      borderTop: vars.borders.outlineVariant,
      paddingTop: vars.space.xs,
    },
  },
  "@media": {
    [`screen and (min-width: ${breakpoints[5]})`]: {
      selectors: {
        "&:last-child": {
          borderTop: 0,
          paddingTop: 0,
        },
      },
    },
  },
});

export const itemLink = style({
  textDecoration: "none",
  color: "currentcolor",
});

export const primaryHeading = style({
  fontFamily: vars.fonts.regular,
  fontSize: vars.fontSizes.body.s,
});

export const primaryValue = style({
  lineHeight: 1,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.heading["5xl"],
});

const chipStatusBase = style({
  zIndex: 1,
  backgroundColor: vars.colors.inverseSurface,
  padding: `${vars.space["2xs"]} 0`,
  width: "100%",
  color: vars.colors.onPrimary,
  fontFamily: vars.fonts.bold,
});

export const chipStatus = styleVariants({
  default: [
    chipStatusBase,
    {
      borderRadius: vars.radii.m,
    },
  ],
  live: [chipStatusBase],
});

export const reloadButton = style([
  chipStatusBase,
  {
    justifyContent: "center",
    borderRadius: `0 0 ${vars.radii.m} ${vars.radii.m}`,
  },
]);

export const primaryPanel = style({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  borderRadius: vars.radii.l,
  backgroundColor: vars.colors.inverseSurface,
  width: "100%",
  height: "100%",
});

export const pointsPanel = style({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: vars.radii.m,
  background: vars.colors.blueBrandGradient,
  color: vars.colors.primaryFixed,
  selectors: {
    '[dir="rtl"] &': {
      background: vars.colors.blueBrandGradientRtl,
    },
  },
});
